<script setup>
  import ComponentGuidelineButton from "@components/Buttons/GuidelineButton.vue";

  defineOptions({
    name: "PagesRecordResultPatientDataDiseases",
  });

  defineProps({
    diseases: {
      type: Object,
      required: true,
    },
  });
</script>

<template>
  <div
    v-if="diseases.length > 0"
    class="py-2 sm:grid sm:grid-cols-4 sm:gap-4"
    :data-test="getTestId('result-diseases')"
  >
    <dt class="font-semibold text-gray-900">Erkrankungen / Allergien / Lebensumstände</dt>
    <dd class="mt-1 text-gray-700 sm:col-span-3 sm:mt-0">
      <ul>
        <li
          v-for="disease in diseases"
          :key="disease.id"
          class="inline-flex items-center whitespace-nowrap after:mr-1 after:content-[',_'] last:after:content-['']"
        >
          <span v-if="disease.disease" class="whitespace-normal">
            {{ disease.disease }}
          </span>
          <span v-else-if="disease.name_icdc" class="whitespace-normal">
            {{ disease.name_icdc }}
            <template v-if="disease.abdata_key_icdc">({{ disease.abdata_key_icdc }})</template>
          </span>

          <ComponentGuidelineButton
            v-if="$page.props.client.license.is_pro && disease.guidelines?.length > 0"
            class="print:hidden"
            :guidelines="disease.guidelines"
            :test-id="getTestId('result-diseases')"
          />
        </li>
      </ul>
    </dd>
  </div>
</template>
